// Vendors
import { AxiosResponse } from "axios";

// Api
import Api from "@/services/api/index";

// Models
import { ResponseIndex } from "@/models/response";

// Services
import { setNotification } from "@/services/app";
import { getStatus } from "@/services/app";

// Store
import store from "@/store/index";

const getRequest = async (options: { uri: string; formData?: any; isProtected?: boolean; isSuccessNotificationVisible?: boolean; isErrorNotificationVisible?: boolean }): Promise<ResponseIndex> => {
  let response: ResponseIndex = new ResponseIndex();

  await Api({
    method: "GET",
    headers: {
      Authorization: `${options.isProtected ? store.getters.getAuthentication.token : ""}`,
    },
    url: `${options.uri}`,
    params: options.formData,
  })
    .then((r: AxiosResponse) => {
      response = {
        data: r.data.content.data ?? null,
        message: r.data.content.message ?? "",
        status: getStatus(r.status),
      };

      if (options.isSuccessNotificationVisible) {
        setNotification(response.message, response.status);
      }
    })
    .catch((e) => {
      response = {
        data: e.response.data.content.data ?? null,
        message: e.response.data.content.message ?? "",
        status: getStatus(e.response.status),
      };

      if (options.isErrorNotificationVisible) {
        setNotification(response.message, response.status);
      }
    });

  return response;
};

const postRequest = async (options: { uri: string; formData?: any; isProtected?: boolean; isSuccessNotificationVisible?: boolean; isErrorNotificationVisible?: boolean }): Promise<ResponseIndex> => {
  let response: ResponseIndex = new ResponseIndex();

  await Api({
    method: "POST",
    headers: {
      Authorization: `${options.isProtected ? store.getters.getAuthentication.token : ""}`,
    },
    url: `${options.uri}`,
    data: options.formData,
  })
    .then((r: AxiosResponse) => {
      response = {
        data: r.data.content.data ?? null,
        message: r.data.content.message ?? "",
        status: getStatus(r.status),
      };

      if (options.isSuccessNotificationVisible) {
        setNotification(response.message, response.status);
      }
    })
    .catch((e) => {
      response = {
        data: e.response.data.content.data ?? null,
        message: e.response.data.content.message ?? "",
        status: getStatus(e.response.status),
      };

      if (options.isErrorNotificationVisible) {
        setNotification(response.message, response.status);
      }
    });

  return response;
};

export { getRequest, postRequest };
